import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextM } from "../../common/text";
import { TextField } from "@mui/material";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const Header = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const RegisterWrapper = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 550px;
    gap: 40px;
  }
`;

export const RegisterNameInput = styled(TextField)`
  width: 50%;
  height: 100px;

  .MuiInputBase-input {
    font-size: 20px;
    font-family: "Bold";
    padding-top: 30px;
    text-align: center;
  }
  label.Mui-focused {
    color: "none";
  }
  .MuiInput-underline:after {
    border-bottom-color: "none";
  }
  .MuiFormHelperText-root {
    color: #f44b59;
  }
  @media ${({ theme }) => theme.device.tablet} {
    height: 45px;
    .MuiInputBase-input {
      font-size: 27px;
      font-family: "Bold";
      padding-top: 30px;
      text-align: center;
    }
    .MuiFormHelperText-root {
      font-size: 18px;
    }
  }
`;

export const GenderWrapper = styled.div`
  width: 260px;

  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin-top: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

export const CheckLabelWrapper = styled.div`
  width: 60%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const CheckLabel = styled.label`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 80px;
  font-family: "Bold";
  font-size: 20px;
  text-align: center;
  @media ${({ theme }) => theme.device.tablet} {
    width: 100px;
    font-size: 30px;
  }
`;

export const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 25px;
    height: 25px;
  }
`;

export const DatePicker = styled.div`
  width: 55%;
  height: 50px;
  border-radius: 5px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 5px #808080;
  margin-top: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 55%;
    height: 80px;
  }
`;

export const YearSelect = styled.select`
  width: 40%;
  height: 48px;

  border: none;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &:focus {
    border: none;
  }

  font-family: "Bold";
  font-size: 18px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;

export const MonthSelect = styled.select`
  width: 30%;
  height: 48px;
  border: none;
  font-family: "Bold";
  font-size: 18px;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;

export const DaySelect = styled.select`
  width: 30%;
  height: 48px;
  border: none;
  font-family: "Bold";
  font-size: 18px;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;

export const Option = styled.option`
  font-family: "Bold";
  font-size: 16px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 20px;
  }
`;

export const NextButton = styled.div`
  width: 55%;
  height: 50px;
  border-radius: 5px;
  margin-top: 20px;
  background-color: ${({ color }) => (color ? color : "#eaeaea")};
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
    height: 60px;
    margin-top: 30px;
  }
`;

export const NextButtonText = styled(TextM)`
  color: ${({ isValidateInfo }) => (isValidateInfo ? "#FFF" : "#9F9F9F")};
`;
